import moment from 'moment';
import { DATE_REQUEST_FORMAT_WITH_SLASH_DELIMITER } from 'utilities/dates_and_times';
import {
  ALL_STATUSES,
  ALL_TAB,
  COMPLETED_STATUSES,
  COMPLETED_TAB,
  FAILED_STATUSES,
  IN_PROGRESS_STATUSES,
  IN_PROGRESS_TAB,
  TOOL_TYPE_NAMES,
} from 'components/TeamOverview/components/AiComputeTransactionsCard/constants';
import { ORDERS_SLIDE_LIST_URL } from 'constants/urls';
import { Link } from 'react-router-dom';
import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import {
  SLIDE_ID_KEY,
  TOOL_TYPE_KEY,
} from 'components/OrderSlidesList/constants';

export const getStatusComponent = (classes, status, slideViewerUrl) =>
  ({
    [IN_PROGRESS_STATUSES]: (
      <Box className={classes.statusContainer}>
        <SyncOutlinedIcon className={classes.icon} />
        <Typography className={classes.defaultLabel}>Processing</Typography>
      </Box>
    ),
    [COMPLETED_STATUSES]: (
      <Box className={classes.statusContainer}>
        <CheckCircleOutlineIcon
          className={`${classes.icon} ${classes.blueText}`}
        />
        <Link
          className={`${classes.link} ${classes.blueText}`}
          to={slideViewerUrl}
        >
          View Result
        </Link>
      </Box>
    ),
    [FAILED_STATUSES]: (
      <Box className={classes.statusContainer}>
        <CancelOutlinedIcon className={`${classes.icon} ${classes.redText}`} />
        <Typography className={`${classes.defaultLabel} ${classes.redText}`}>
          Failed
        </Typography>
      </Box>
    ),
  }[status]);

export const getSlideViewerURL = (slide, toolType) =>
  ORDERS_SLIDE_LIST_URL.replace(':orderUUID', slide?.order?.uuid).concat(
    `#${SLIDE_ID_KEY}=${slide.uuid}&${TOOL_TYPE_KEY}=${toolType}`,
  );

export const mlModelsSorter = (a, b) =>
  new Date(b.createdAt) - new Date(a.createdAt);

export const parseMlModels = (mlModels) =>
  mlModels.reduce((acc, mlModel) => {
    const logs = mlModel.slide_ml_processing_logs;
    const userFullName = `${mlModel.user.first_name} ${mlModel.user.last_name}`;
    const transactions = logs.map((log) => ({
      uuid: log.uuid,
      orderName: log.slide?.order?.id,
      slideName: log.slide?.name,
      toolType: TOOL_TYPE_NAMES[mlModel.processing_type],
      aiModel: mlModel.processing_type,
      cost: mlModel.price_per_slide,
      status: log.state,
      statusGroup: ALL_STATUSES.find((statusesGroup) =>
        statusesGroup.includes(log.state),
      ),
      sourceUrl: mlModel.app_source_location_url,
      slideViewerUrl: COMPLETED_STATUSES.includes(log.state)
        ? getSlideViewerURL(log.slide, mlModel.processing_type)
        : '',
      processedOnDate: moment(log.created).format(
        DATE_REQUEST_FORMAT_WITH_SLASH_DELIMITER,
      ),
      createdAt: log.created,
      processingDetails: `COMPUTE OPERATION: DATE = ${moment(
        log.created,
      ).format(DATE_REQUEST_FORMAT_WITH_SLASH_DELIMITER)} BY ${userFullName}`,
    }));

    return [...acc, ...transactions];
  }, []);

export const prepareModelSelectOptions = (models) => {
  const uniqueModels = [...new Set(models.map((m) => m.aiModel))];
  const options = uniqueModels.map((model) => ({
    value: model,
    ...TOOL_TYPE_NAMES[model],
  }));

  return [...options];
};

export const filterMlModelsBySubstring = (stringifiedModelsMap, filter) => {
  const lowerCaseFilter = filter.toLowerCase();

  return stringifiedModelsMap
    .entries()
    .reduce(
      (acc, [modelObject, stringifiedModel]) =>
        stringifiedModel.includes(lowerCaseFilter)
          ? [...acc, modelObject]
          : acc,
      [],
    );
};

export const filterModelsByState = (models, status) =>
  ({
    [ALL_TAB]: models,
    [COMPLETED_TAB]: models.filter((model) =>
      COMPLETED_STATUSES.includes(model.status),
    ),
    [IN_PROGRESS_TAB]: models.filter((model) =>
      IN_PROGRESS_STATUSES.includes(model.status),
    ),
  }[status]);

export const stringifyModels = (models) => {
  const modelsMap = new Map();
  models.forEach((model) => {
    modelsMap.set(model, JSON.stringify(model).toLowerCase());
  });

  return modelsMap;
};
